import type { LeadPackagePrice, LeadPricingOffer } from 'src/services/LeadStreamsService/agent';

// The local frontend points at the production API. Until the API exposes the
// annual offer for every active category, show its price without enabling checkout.
export function annualOfferPreview(prices: LeadPackagePrice[]): LeadPricingOffer | null {
    if (process.env.NODE_ENV !== 'development') return null;
    return calculateAnnualOfferPreview(prices);
}

export function calculateAnnualOfferPreview(prices: LeadPackagePrice[]): LeadPricingOffer | null {
    const business = prices.find((price) => price.package_size === 200);
    const monthlyUnit = Number(business?.monthly_price_per_lead);
    if (!Number.isFinite(monthlyUnit) || monthlyUnit <= 0) return null;
    const comparison = Math.round(monthlyUnit * 200 * 12 * 100) / 100;
    const total = Math.round(comparison * 0.7 * 100) / 100;
    return {
        id: 'local-annual-preview',
        code: 'leadsmania-annual-unlimited-12m',
        kind: 'annual_unlimited',
        title: 'Годовой безлимит',
        is_recommended: false,
        currency: 'RUB',
        delivery_mode: 'stream',
        price: total.toFixed(2),
        billing_period_months: 12,
        access_duration_days: 365,
        metadata: { comparison_total: comparison.toFixed(2), prepayment_discount_percent: 30 },
    };
}
